function readValue(key) {
  const value = localStorage.getItem(key);

  if (value === null) {
    return undefined;
  }

  try {
    return JSON.parse(value);
  } catch (e) {
    return value;
  }
}

export function setCookie(name, value, hours = 24) {
  let str = name + "=" + value;
  const time = new Date(new Date().getTime() + hours * 3600 * 1000).toGMTString();
  str += "; expires=" + time;
  str += ";path=/";
  document.cookie = str;
}

export function getCookie(name) {
  const reg = new RegExp("(^| )" + name + "=([^;]*)(;|$)");
  const arr = document.cookie.match(reg);
  if (arr !== null) {
    return arr[2];
  } else {
    return null;
  }
}

export function clearCookie(name) {
  document.cookie.split(";").forEach(() => {
    setCookie(name, "", -1);
  });
}

export default {
  get(key, fallback) {
    const value = readValue(key);
    return value === undefined ? fallback : value;
  },
  set(key, value) {
    localStorage.setItem(key, JSON.stringify(value));
    return value;
  },
  remove(key) {
    localStorage.removeItem(key);
  }
};
